import React, { useState, useEffect } from "react";
import { Card, message, Table, Input } from "antd";
import { columns } from "./columns";
import { apiGetMember } from "api/api";

const Members = () => {
  const { Search } = Input;

  const [tableData, setTableData] = useState([]);
  const [fuzzySearch, setFuzzySearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await apiGetMember({
        fuzzySearch,
        limit: pageSize,
        offset: current * pageSize - pageSize,
      });
      const { content, paging } = res.data;
      setTableData(content);
      setTotal(paging.count);
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // # 表格變化
  const onTableChange = (pagination) => {
    setCurrent(pagination.current);
  };

  // # 變更每頁顯示數量
  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };

  // # 搜尋
  const onSearch = (value) => {
    setFuzzySearch(value);
  };

  useEffect(() => {
    fetchData();
  }, [fuzzySearch, current, pageSize]);

  return (
    <Card
      title={<h3 className="text-left">會員列表</h3>}
      className="text-center mt-5 rounded-3xl px-10 sm:px-0 min-h-[calc(100vh-250px)]"
    >
      <Search
        placeholder="姓名、電話、Email"
        allowClear
        enterButton="搜尋"
        size="large"
        onSearch={onSearch}
        className="mb-5"
      />
      <Table
        columns={columns}
        dataSource={tableData}
        loading={isLoading}
        onChange={onTableChange}
        scroll={{ x: "100%" }}
        pagination={{
          total,
          current,
          pageSize,
          showSizeChanger: true,
          onShowSizeChange,
          showTotal: () => `共 ${total} 筆`,
        }}
      ></Table>
    </Card>
  );
};

export default Members;
